import { Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DriverCredentialService } from '../credential-service/driver-credential.service';

@Component({
  selector: 'app-credentialed-drivers-list',
  templateUrl: './credentialed-drivers-list.component.html',
  styleUrls: ['./credentialed-drivers-list.component.css']
})
export class CredentialedDriversListComponent implements OnInit, OnDestroy {
  search: any;
  drivers: any;
  user: any;

  constructor(
    private sharedDataService: SharedDataService,
    private credentialDriverService: DriverCredentialService
  ) { }

  ngOnInit() {
    this.getUser();
    this.getDrivers();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
        }
      });
  }

  getDrivers() {
    this.credentialDriverService.getDrivers()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (data && data.length) {
          this.drivers = data;
        }
      }
      );
  }

  ngOnDestroy(): void {
  }
}
